<template>
  <div class="table_container">
    <div class="table_header">
      <div class="row p-3">
        <div class="col-md-6">
          <label for="tbl-name">Table Name</label>
          <input type="text" class="form-control" v-model="tableName" id="tbl-name" placeholder="Search Tables">
        </div>
        <div class="col-md-6">
          <label for="usersList">User</label>
          <v-select id="usersList" v-model="createdUser"
                    :options="users">
            <template slot="no-options">
              <b>Type to search ...</b>
            </template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="table-contents-container">
      <div class="open_tables">
        <div class="container-fluid d-flex justify-content-center">
          <div class="row wrapper">
            <SingleTable @click="openTable(tab)" v-for="tab in filterTables" :tab="tab" :key="tab.SaleNum"/>
          </div>
        </div>
        <OpenTableSheet ref="tableSheet" @updateAction="getOpenTables" :tab="setTable"/>
      </div>

      <div class="vertical-line"></div>
      <div class="routes">
        <div class="text-center d-flex justify-content-between align-items-center px-3 m-2">
          <span class="fw-bold">Expected Turnover : {{ $utils.formatMoney(total + tipsTotal) }} </span>
        </div>
        <hr class="mx-3"/>
        <ul>
          <li>
            <router-link :to="{ name : `create-table` }">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="plus"/>
              </div>
              Open New Table
            </router-link>
          </li>

          <li>
            <a @click="mergeTable">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="code-merge"/>
              </div>
              Merge Tables
            </a>
          </li>

          <li v-if="!androidMode">
            <a @click="openCashDrawer">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="cash-register"/>
              </div>
              Open Cash Drawer
            </a>
          </li>

          <CapturePayout/>

          <li>
            <a @click="userCashup">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="coins"/>
              </div>
              End User Shift
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import SingleTable from "@/components/point-of-sale/table/SingleTable";
import OpenTableSheet from "@/components/point-of-sale/table/OpenTableSheet";
import {Storage} from "@/services/Storage";
import CapturePayout from "@/components/point-of-sale/Accounts/CapturePayout";
import { error } from "jquery";
import { errorHandler } from "@/services/errorHandler";

export default {
  name: "AllTables",
  components: {CapturePayout, OpenTableSheet, SingleTable},
  computed: {
    nameSearch() {
      return this.tables.filter(table => {
        return table.Name.toLowerCase().includes(this.tableName.toLowerCase()) ||
            table.total.toString().toLowerCase().includes(this.tableName.toLowerCase() ||
                table.customer.toLowerCase().includes(this.tableName.toLowerCase()))
      });
    },
    filterTables() {
      return this.nameSearch.filter(table => {
        let createdUser = this.createdUser;
        if (!createdUser) createdUser = ``;
        return table.user.toLowerCase().includes(createdUser.toLowerCase());
      })
    },
    users() {
      let usersToSearch = [];
      for (let i = 0; i < this.tables.length; i++) {
        let user = this.tables[i].user;
        if (!usersToSearch.includes(user)) {
          usersToSearch.push(user);
        }
      }
      return usersToSearch;
    },
    total() {
      let tables = this.tables;
      if (!tables) return 0.00;
      let total = 0;
      for (let i in tables) {
        let tab = tables[i];
        let tabTotal = 0;
        let items = tab.items;
        for (let j = 0; j < items.length; j++) {
          tabTotal += items[j].Line;
          let instructions = items[j].instructions;
          if (instructions) {
            for (let k = 0; k < instructions.length; k++) {
              let price = instructions[k].Price;
              total += price;
            }
          }
        }
        this.tables[i].total = parseFloat(tabTotal.toFixed(2));
        total += tabTotal;
      }
      return total;
    },

    settings() {
      return this.$store.getters.getDeviceSettings;
    },

  },
  async beforeMount() {
    this.getOpenTables()
  },
  data() {
    return {
      tableName: '',
      createdUser: ``,
      tipsTotal: 0,
      setTable: {},
      tables: [],
      androidMode: false,
    }
  },
  methods: {
    getOpenTables() {
      this.$utils.showLoading()
      return this.$store.dispatch('getAllTables')
          .then((res) => {
            this.tables = res
            this.totalTip()
          }).finally(() => this.$utils.hideLoading())
    },
    async openTable(tab) {
      let store = await Storage.getDefaultStore();
      if (tab.inUse) {
        let isAllowed = await this.$store.dispatch('validateSecurityPermission', 'overrideTable');
        if (isAllowed) {
          const result = await Swal.fire({
            title: 'Warning!',
            text: 'This table is currently in use. Are you sure you want to override and open it?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, override it!',
            cancelButtonText: 'Cancel'
          });
          
          if (!result.isConfirmed) {
            return;
          }
          let supervisor = await Storage.getSupervisor();
          if (!supervisor) {
            let user = await Storage.getCurrentUser();
            supervisor = user.Username;
          }

          try {
            const response = await axios.post(serverApi + `tables/${store.StoreDB}/overrideOpenTable/${tab.saleNumber}?user=${supervisor}`);
            if (response.status === 200) {
              await this.getOpenTables();
              this.setTable = tab;
              this.$refs.tableSheet.open();
            } 
          } catch (error) {
            errorHandler.tomcatError(error);
            console.error(error);
          }
        }
        if (!isAllowed) {
          errorHandler.tomcatError(new Error('You do not have permission to access this table'), true, 'Permission Denied');
          return;
        }
      }
      this.setTable = tab;
      this.$refs.tableSheet.open();
    },
    async totalTip() {
      let saleTotal = this.total;
      let settings = await Storage.getDeviceSettings();
      let tip = 0;
      if (settings && settings.AutoTip > 0) {
        tip = Number(settings.AutoTip);
        tip = (tip / 100) * saleTotal;
      }
      this.tipsTotal = tip;
    },
    async mergeTable() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `mergeTable`);
      if (isAllowed) return this.$router.push({name: `merge-tables`});
    },
    async userCashup() {
      let openTables = this.tables.length;
      if (openTables > 0) {
        let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `cashupWithOpenTables`);
        if (!isAllowed) return;
      }
      return this.$router.push({name: `cashup`})
    },
    async doPayout() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `Payout`);
      if (isAllowed) {
        responses.showInfo(`Doing Payout`)
      }
    },
    async openCashDrawer() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `OpenDrwer`);
      if (isAllowed) return this.$store.dispatch(`openCashDrawer`)
    },
  }
}
</script>

<style lang="scss" scoped>
//table css
.vertical-line {
  border-left: 1px solid #d4d4d4;
  height: 100vh;
  margin-left: 1px;

}

.table_container {
  display: flex;
  flex-direction: column;
}

.table-contents-container {
  display: grid;
  grid-template-columns: 1fr auto auto;
  padding: 0.5em;
}

.routes {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      padding: 0;
      border: #f1f1f1 solid 1px;
      border-radius: 5px;
      margin: 0.5em;

      .list-item, a {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 600;
        font-size: 20px;
        padding: 10px;
        text-decoration: none;
        color: #1c1c1c;

        .icon-box {
          width: 35px;
          margin-right: 10px;
          display: flex;
          justify-content: center;

          .icon {
            font-size: 25px;
            color: #34373C;
          }
        }

        &:hover, &.router-link-exact-active {
          background: #f1f1f1;
          color: #1e88e5;
          font-weight: 700;

          .icon-box {
            .icon {
              color: #1e88e5;
            }
          }
        }
      }
    }

  }
}


.wrapper {
  //display: grid;
  //grid-template-columns: 50% 50%;
  width: 100%;
  gap: 5px;
  padding: 6px;
  //grid-gap: 10px;
}

@media screen and (min-width: 501px) {
  .wrapper {
    grid-template-columns: 33.33% 33.33% 33.33%;
  }

}

@media screen and (min-width: 770px) {
  .wrapper {
    grid-template-columns: 25% 25% 25% 25%;
  }
}
</style>
